type SharedButtonApiProps = {
  loading?: boolean
  disabled?: boolean
  primary?: boolean
  destructive?: boolean
  icon?: React.ReactNode
  text?: boolean
  fullWidth?: boolean
  selected?: boolean
  // React.HTMLAttributes allows color to be passed in, but we don't want to allow it
  color?: never
}

type SharedConditionalTextProps =
  | {
      text: true
      icon: React.ReactNode
      children?: never | false | undefined | null
      fullWidth?: never | false
    }
  | {
      text: true
      icon?: never
      fullWidth?: never | false
    }
  | {
      text?: false
    }

type SharedConditionalVariantProps =
  | {
      size?: "large"
      variant?: never
    }
  | {
      size: "small"
      destructive?: false
      primary?: false
      selected?: false
      // Those variants are only available for small buttons
      variant:
        | "warning"
        | "secondary"
        | "tertiary"
        | "business"
        | "success"
        | "neutral"
    }
  | {
      size?: "small"
      variant?: never
    }

// Button props
export type ButtonComponentProps =
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    loading?: SharedButtonApiProps["loading"]
    disabled?: SharedButtonApiProps["disabled"]
    href?: never
  }

// Link props
export type ButtonLinkComponentProps =
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    loading?: SharedButtonApiProps["loading"]
    disabled?: SharedButtonApiProps["disabled"]
    href?: string
  }

export const isLinkProps = (
  props: ButtonComponentProps | ButtonLinkComponentProps,
): props is ButtonLinkComponentProps => "href" in props && !!props.href

export type ButtonProps = (ButtonComponentProps | ButtonLinkComponentProps) &
  SharedButtonApiProps &
  SharedConditionalVariantProps &
  SharedConditionalTextProps
